import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500">
                <i className="ri-film-line text-lg text-primary-950" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                嫂子的职业在线观看
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              专注高清电视剧资源整理与在线观看体验，收录都市、职场、情感、悬疑等题材剧集，
              为剧迷提供清晰的分类、筛选与剧集资料查询服务。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站内容为演示站点，所有剧集资料均为模拟数据，播放功能仅做前端交互演示，不提供任何真实视频流。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="text-sm font-medium text-background-50">
                <Link to="/category" className="hover:text-accent-400">
                  内容导航
                </Link>
              </h4>
              <ul className="mt-3 space-y-2 text-xs text-background-300">
                <li>
                  <Link to="/" className="hover:text-accent-400">首页推荐</Link>
                </li>
                <li>
                  <Link to="/category" className="hover:text-accent-400">电视剧分类</Link>
                </li>
                <li>
                  <Link to="/search" className="hover:text-accent-400">全站搜索</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-medium text-background-50">
                <Link to="/category" className="hover:text-accent-400">
                  热门题材
                </Link>
              </h4>
              <ul className="mt-3 space-y-2 text-xs text-background-300">
                <li>
                  <Link to="/category" className="hover:text-accent-400">都市情感</Link>
                </li>
                <li>
                  <Link to="/category" className="hover:text-accent-400">职场商战</Link>
                </li>
                <li>
                  <Link to="/category" className="hover:text-accent-400">悬疑推理</Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-sm font-medium text-background-50">
                <Link to="/about" className="hover:text-accent-400">
                  关于本站
                </Link>
              </h4>
              <ul className="mt-3 space-y-2 text-xs text-background-300">
                <li>
                  <Link to="/about" className="hover:text-accent-400">网站定位</Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-accent-400">免责声明</Link>
                </li>
                <li>
                  <Link to="/about#feedback" className="hover:text-accent-400">意见反馈</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 嫂子的职业在线观看 · 演示站点，仅供学习与展示使用</p>
          <p>本站不存储、不传播任何影视资源文件</p>
        </div>
      </div>
    </footer>
  );
}